import getAxiosInstance from "../../common/mhiAxios";
import { Project } from "../../models/project";
import { isEmpty, isNull, isNullorUndefined } from "../../utils/ObjectUtils";

export default {
    // プロジェクト一覧取得
    GetAllProjectList(userId: string): Promise<any> {
        return getAxiosInstance().get("/api/getProjectList", {params: {userId: userId}})
        .then(({data}) => data)
        .catch((error) => {return error});
    },
    GetProjectByProfessional(userId: string, id: string[]): Promise<any> {
        return getAxiosInstance().get("/api/getProjectList", {params: {userId: userId, professionalId: id[0]}})
            .then(({data}) => data)
            .catch((error) => {return error});
    },
    // プロジェクト一覧更新
    UpdateProject(userId: string,projectList: Project[]): Promise<any> {
        const params = new FormData();
        let projects = "";
        params.append("userId", userId)
        projectList.map((project) => {
            params.append("file", isNullorUndefined(project.file) ? new File([""], "") : project.file);
            let videoIds: any[] = [];
            project.videos.map((video) => (videoIds.push(String(video.id))));

            if (!isEmpty(projects)) {
                projects = projects + "," + JSON.stringify({
                    id: project.id,
                    title: project.title,
                    description: project.description,
                    period: project.period,
                    imageUrl: project.imageUrl,
                    videoIds: isNull(videoIds) ? [] : videoIds
                });
            } else {
                projects = JSON.stringify({
                    id: project.id,
                    title: project.title,
                    description: project.description,
                    period: project.period,
                    imageUrl: project.imageUrl,
                    videoIds: isNull(videoIds) ? [] : videoIds
                });
            }
            return null;
        });

        if (projectList.length === 0) {
            params.append("file", new File([""], ""));
            params.append("project", new Blob([" "], {type: "application/json"}));
        } else {
            params.append("project", new Blob([projects], {type: "application/json"}));
        }

        return getAxiosInstance().post("/api/updateProject", params, {headers: {"content-type": "multipart/form-data"}})
            .then(({data}) => data)
            .catch((error) => {return error});
    },
    AddVideoToProject(userId: string, projectId: string, videoId: string): Promise<void> {
        return getAxiosInstance().post("/api/addVideoToProject", {userId: userId, projectId: projectId, videoId: videoId})
            .then(({data}) => data)
            .catch((error) => {return error});
    },
};